import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";

const API = process.env.REACT_APP_API;
const ChartActividades = () => {
  const [series, setSeries] = useState([{ data: [] }]); // Evita errores de .length
  const [categories, setCategories] = useState([]); // Evita errores de .length

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API}/api/members/totalActividad`);

        // Verificar si la respuesta tiene datos
        if (response.data && response.data.length > 0) {
          const actividades = response.data.map(item => item.actividad);
          const cantidades = response.data.map(item => item.cantidad);

          setCategories(actividades);
          setSeries([{ data: cantidades }]);
        }
      } catch (error) {
        console.error("Error fetching totalActividad:", error);
      }
    };

    fetchData();
  }, []);

  const options = {
    chart: {
      toolbar: { show: false },
    },
    plotOptions: {
      bar: { horizontal: true },
    },
    dataLabels: { enabled: false },
    colors: ["#34c38f"],
    grid: { borderColor: "#f1f1f1" },
    xaxis: {
      categories: categories.length > 0 ? categories : ["Cargando..."], // Evita errores en ApexCharts
    },
    tooltip: {
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          return `<div style="padding: 10px; background: white; border: 1px solid #ddd; border-radius: 5px;">
                    <strong>${w.globals.labels[dataPointIndex]}</strong>: 
                    ${series[seriesIndex][dataPointIndex]} miembros
                  </div>`;
        },
      },
    
  };

  return (
    <>
      {categories.length > 0 && series[0].data.length > 0 ? (
        <ReactApexChart options={options} series={series} type="bar" height="350" />
      ) : (
        <p>Cargando datos...</p> // Mensaje mientras carga la API
      )}
    </>
  );
};

export default ChartActividades;
